import { PackageUpdateForm } from "models/package";
import axiosClient from "./axiosClient";
import { ApiResponse, RemovePayload, ImageUrlData } from "models";

const couponManageApi = {
  getCouponList(data: any): Promise<any> {
    return axiosClient.get(`/couponManage/getallCouponData`, {
      params: {
        limit: data.limit,
        page: data.page,
        region: data.region,
        search: data.search,
        sortField: data.sortName,
        sortType: data.sortType,
      }
    });
  },

  addCoupon(data: any): Promise<ApiResponse> {
    return axiosClient.post(`/couponManage/addCoupon`, data);
  },

  updateCoupon(data: PackageUpdateForm): Promise<ApiResponse> {
    return axiosClient.put(`/couponManage/updateCoupon`, data);
  },

  deleteCoupon(data: RemovePayload): Promise<ApiResponse> {
    return axiosClient.post(`/couponManage/removeCoupon`, null, {
      params: { id: data._id }
    });
  },

  getImageUrl(data: ImageUrlData): Promise<ApiResponse> {
    return axiosClient.post(`/settings/uploadImage`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export default couponManageApi;
